import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=4b7571bc&scoped=true"
import script from "./Preview.vue?vue&type=script&lang=js"
export * from "./Preview.vue?vue&type=script&lang=js"
import style0 from "./Preview.vue?vue&type=style&index=0&id=4b7571bc&prod&lang=scss&scoped=true"
import style1 from "./Preview.vue?vue&type=style&index=1&id=4b7571bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7571bc",
  null
  
)

export default component.exports